import React from "react";
import { Card, Image, Rating, Grid, Divider, Label, Header, Icon } from "semantic-ui-react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import img1 from "../../../../assets/images/insp1.png"
import img2 from "../../../../assets/images/insp2.png"
import { useTranslation } from "react-i18next";
import "./SearchResidenceCard.css"


const SearchResidenceCard = ({ data }) => {
  const { t } = useTranslation();

  return data && data.length !== 0 ? data.map((item, index) => {
    return (
      <>
        <Grid.Row className="boxshadow-none rounded-15 w-100 m-2-b m-2-t">
          <Grid columns={2} unstackable>
            <Grid.Column width={6} className="p-4px">
              <Swiper
                modules={[Navigation]}
                navigation
                loop={true}
                pagination={{ clickable: true }}
                onSlideChange={() => console.log("changed")}
                onSwiper={(swiper) => console.log(swiper)}
                slidesPerView={1}
                spaceBetween={50}
                className="w-100"

              >
                <SwiperSlide>
                  <Image src={img1} size="large" className="w-100 h-100 rounded-20" />
                </SwiperSlide>
                <SwiperSlide>
                  <Image src={img2} size="large" className="w-100 h-100 rounded-20" />
                </SwiperSlide>
              </Swiper>
            </Grid.Column>
            <Grid.Column width={10}>

              <div className="d-flex flex-column justify-content-between h-100">
                <span>
                  <div className="d-flex flex-row justify-content-between m-05">
                    <Header as="h3" className="font-bold d-flex flex-row align-items-center">  {item.location}</Header>
                    <Rating size="large" className="bg-white rounded-10 p-05" icon='heart' defaultRating={1} maxRating={1} />


                  </div>
                  <div className="font-thin">
                    {
                      item.type === "immidiate" ? <Label size="tiny" color="orange" className="m-05-r m-05-l">{t("property:ImmidiateRelocation")}</Label> :
                        item.type === "new" ? <Label size="tiny" color="blue" className="m-05-r m-05-l">{t("property:New")}</Label>
                          : null
                    }
                    <span className="font-thin m-05-r m-05-l">{item.description}</span>
                  </div>

                </span>

                <div className="d-flex flex-column justify-content-between flex-wrap">

                  <Label size="large" basic className="p-0 border-none d-flex flex-row align-items-center ">
                    {t("property:PricePerNight")} :
                    <span className=" m-05-r m-05-l"> {item.pricePerNight} </span>
                  </Label>
                  <span className="d-flex flex-row align-items-center m-1-t">
                    <Icon name="star" color="red" className="m-05-b"/>
                    <span className="font-bold"> ۳.۵</span>
                    <span className="font-thin m-05-r m-05-l">( ۳ {t("property:Reviews")} )</span>
                    
                  </span>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </Grid.Row>
        <Divider />
      </>
    )
  }) : null

}
export default SearchResidenceCard